module.exports = __webpack_public_path__ + "img/dahuangmi.29e01a18.jpg";